import React, { useContext } from "react";
import axios from "axios";
import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Footer from "../components/Footer";
import Global, { formatLongNumber } from "../util/Global";
import { useTranslation } from "react-i18next";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { Menu, MenuItem, IconButton } from '@mui/material';
import ShareIcon from '@mui/icons-material/Share';
import FacebookIcon from '@mui/icons-material/Facebook';
import TwitterIcon from '@mui/icons-material/Twitter';
import EmailIcon from '@mui/icons-material/Email';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import Mapss from "./Mapss";
import { LoaderComponent } from "../util/Loader";
import ProductsComponent from "../components/Products/ProductsComponent";
import AdsComponent from "../components/Ads/AdsComponent";
import { AlertContext } from "../util/Alerter";
import NotFound from "../components/NotFound";
import OpeningHours from "../components/OpeningHours";
import { CurrencyContext } from "../components/Utils"
import { GlobalData } from "../util/GlobalData";


const ProfileEntreprise = () => {
  const { idOrName } = useParams();
  const navigate = useNavigate()
  const { t } = useTranslation();
  const [productList, setProductList] = useState([]);
  const [adsList, setadsList] = useState([]);
  const [isLoading, setisLoading] = useState(true)
  const [userDetail, setUserDetail] = useState("");
  const { showAlert } = useContext(AlertContext)
  const [isAdsProductsLoading, setisAdsProductsLoading] = useState(true)
  const { currency, getCurrencyPrice } = useContext(CurrencyContext)

  const USERS_URL = Global.backend + "/index.php/user/showEn";
  const ADS_URL = Global.backend + "/index.php/myAds";
  const PRODUCTS_URL = Global.backend + "/index.php/produit/myProducts";



  const [sharePopup, setSharePopup] = useState(null);

  const handleClick = (event) => {
    setSharePopup(event.currentTarget);
  };

  const handleClose = () => {
    setSharePopup(null);
  };

  const handleShare = (platform) => {
    handleClose();
    // Logic for sharing on the selected platform
    switch (platform) {
      case 'facebook':
        window.open('https://www.facebook.com/sharer/sharer.php?u=' + window.location.href, '_blank');
        break;
      case 'twitter':
        window.open('https://twitter.com/intent/tweet?url=' + window.location.href, '_blank');
        break;
      case 'linkedin':
        window.open('https://www.linkedin.com/cws/share?url=' + window.location.href, '_blank');
        break;
      case 'email':
        window.location.href = `mailto:?subject=Check this out&body=${window.location.href}`;
        break;
      default:
        break;
    }
  };







  useEffect(() => {
    setisLoading(true)


    axios.all([
      axios.post(USERS_URL, isNaN(idOrName) ? { name: idOrName } : { userId: idOrName }),
    ]).then(axios.spread((userDetailsResponse) => {
      if (!userDetailsResponse.data) {
        return
      }

      setisAdsProductsLoading(true)
      setUserDetail(userDetailsResponse.data)

      axios.all([
        axios.post(ADS_URL, { userId: userDetailsResponse.data.id }),  // pass user id not entreprise id
        axios.post(PRODUCTS_URL, { userId: userDetailsResponse.data.id }) // pass user id not entreprise id
      ]).then(axios.spread((adsResponse, productsResponse) => {
        setadsList(adsResponse.data.filter(ad => ad.etat == 1))
        setProductList(productsResponse.data.filter(prod => prod.visibilite))
      })).catch(() => {

      })
        .finally(() => {
          setisAdsProductsLoading(false)
        })



    })).catch((error) => {
      showAlert("error", t("request.errorFetchingUserData"))
    }).finally(() => {
      setisLoading(false)
    })
  }, [])













  return (
    <>
      <LoaderComponent isLoading={isLoading}>
        {!isLoading && (
          !userDetail ? <NotFound /> :
            <>


              <div className="site-main mt-5">
                <div className="ttm-row sidebar ttm-bgcolor-grey ttm-sidebar-right clearfix" >
                  <div className="col-md-10" style={{ marginLeft: "auto", marginRight: "auto" }}>
                    <div className="row">

                      <div className="col-md-12">
                        <div className="card mb-3" >
                          <div className="card-body">
                            <div className="row">
                              <div className="col-md-2 d-flex justify-content-center">
                                <img style={{ marginTop: "auto", marginBottom: "auto" }} src={`${Global.backend}/uploads/${userDetail.entreprise.logo}`} />
                              </div>


                              <div className="col-md">
                                <div className="title">
                                  <h1>{userDetail.entreprise.nom}</h1>

                                </div>
                                <div className="detail d-flex" style={{ flexDirection: "column" }}>

                                  {userDetail.entreprise.adresse &&
                                    <h6>
                                      <i className="mdi mdi-map-marker mr-1"></i>
                                      {userDetail.entreprise.adresse}, {userDetail.entreprise.ville}, {userDetail.entreprise.code_postal}
                                    </h6>
                                  }



                                  {userDetail.entreprise.pays &&
                                    <h6>
                                      <i className="mdi mdi-flag mr-1"></i>
                                      {userDetail.entreprise.pays}
                                    </h6>
                                  }



                                  {userDetail.entreprise.site.includes("http") && (
                                    <h6>
                                      <i className="mdi mdi-web mr-1"></i>
                                      <a href={userDetail.entreprise.site} target="_blank">{userDetail.entreprise.site}</a>
                                    </h6>
                                  )}

                                </div>
                              </div>

                              <div className="col-md-3 d-flex align-items-center mb-auto">
                                <IconButton
                                  aria-controls="share-menu"
                                  aria-haspopup="true"
                                  onClick={handleClick}
                                  color="primary"
                                >
                                  <ShareIcon />
                                </IconButton>
                                <Menu
                                  id="share-menu"
                                  anchorEl={sharePopup}
                                  open={Boolean(sharePopup)}
                                  onClose={handleClose}
                                >
                                  <MenuItem onClick={() => handleShare('facebook')}>
                                    <FacebookIcon sx={{ mr: 1 }} /> {t("user.facebook")}
                                  </MenuItem>
                                  <MenuItem onClick={() => handleShare('twitter')}>
                                    <TwitterIcon sx={{ mr: 1 }} /> {t("user.twitter")}
                                  </MenuItem>
                                  <MenuItem onClick={() => handleShare('linkedin')}>
                                    <LinkedInIcon sx={{ mr: 1 }} /> {t("user.linkedin")}
                                  </MenuItem>
                                  <MenuItem onClick={() => handleShare('email')}>
                                    <EmailIcon sx={{ mr: 1 }} /> {t("email")}
                                  </MenuItem>
                                </Menu>

                                <button onClick={() => {
                                  navigate("/dashboard/user/chat?userId=" + userDetail.id)
                                }} className="btn btn-success product-add-to-cart-btn rounded-pill w-100">{t("profileentreprise8.1")}
                                </button>
                              </div>


                            </div>
                          </div>
                        </div>
                      </div>




                      <div className="col-md-4">
                        <div className="card mb-3">
                          <div className="card-body">
                            <div className="card-title"><h4> {t("profileentreprise9.1")} </h4></div>


                            <div className="ligne">
                              <span className="titleligne">{t("user.companyName")}:</span>
                              <span className="descriptionligne">{userDetail.entreprise.nom}</span>
                            </div>





                            <div className="ligne">
                              <span className="titleligne">{t("user.pays")}</span>
                              <span className="descriptionligne">{userDetail.entreprise.pays}</span>
                            </div>



                            <div className="ligne">
                              <span className="titleligne">{t("user.address")}</span>
                              <span className="descriptionligne">{userDetail.entreprise.adresse}</span>
                            </div>

                            <div className="ligne">
                              <span className="titleligne">{t("user.city")}</span>
                              <span className="descriptionligne">{userDetail.entreprise.ville}</span>
                            </div>

                            <div className="ligne">
                              <span className="titleligne">{t("user.postalCode")}</span>
                              <span className="descriptionligne">{userDetail.entreprise.code_postal}</span>
                            </div>




                            <hr />

                            <div className="card-title"><h4> {t("legalInfo")} </h4></div>




                            <div className="ligne">
                              <span className="titleligne">{t("user.activity")} </span>
                              <span className="descriptionligne">{t("user.activities." + userDetail.entreprise.activite)}</span>
                            </div>


                            <div className="ligne">
                              <span className="titleligne">{t("user.dateCreation")} </span>
                              <span className="descriptionligne">{userDetail.entreprise.datecreation}</span>
                            </div>


                            {userDetail.entreprise.forme_juridique &&
                              <div className="ligne">
                                <span className="titleligne">{t("user.legalStructure")} </span>
                                <span className="descriptionligne">{t("user.legalStructures." + userDetail.entreprise.forme_juridique)}</span>
                              </div>
                            }


                            <div className="ligne">
                              <span className="titleligne">{t("user.imm")} </span>
                              <span className="descriptionligne">{userDetail.entreprise.imm}</span>
                            </div>


                            <div className="ligne">
                              <span className="titleligne">{t("user.tva")} </span>
                              <span className="descriptionligne">{userDetail.entreprise.tva}</span>
                            </div>


                            {userDetail.entreprise.chiffre_affaire_annuel ?
                              <div className="ligne">
                                <span className="titleligne">{t("user.annualRevenue")} </span>
                                <span className="descriptionligne">{GlobalData.currency[currency]}{formatLongNumber(getCurrencyPrice(userDetail.entreprise.chiffre_affaire_annuel, userDetail.entreprise.currency))}</span>
                              </div>
                              :
                              ""
                            }


                            {userDetail.entreprise.nb_employe ?
                              <div className="ligne">
                                <span className="titleligne">{t("user.nbEmployees")} </span>
                                <span className="descriptionligne">{formatLongNumber(userDetail.entreprise.nb_employe)}</span>
                              </div>
                              :
                              ""
                            }



                            <hr />

                            <div className="card-title"><h4> {t("user.contactDetails")} </h4></div>

                            <div className="ligne">
                              <span className="titleligne">{t("user.mail")} </span>
                              <span className="descriptionligne">{userDetail.entreprise.email}</span>
                            </div>

                            <div className="ligne">
                              <span className="titleligne">{t("user.fax")} </span>
                              <span className="descriptionligne">{userDetail.entreprise.fax}</span>
                            </div>


                            <div className="ligne">
                              <span className="titleligne">{t("user.phone")} </span>
                              <span className="descriptionligne">{userDetail.entreprise.tel}</span>
                            </div>

                            {userDetail.entreprise.mobile &&
                              <div className="ligne">
                                <span className="titleligne">{t("user.mobile")}</span>
                                <span className="descriptionligne">{userDetail.entreprise.mobile}</span>
                              </div>
                            }


                            {userDetail.entreprise.whatsapp &&
                              <div className="ligne">
                                <span className="titleligne">{t("user.whatsapp")}</span>
                                <span className="descriptionligne">{userDetail.entreprise.whatsapp}</span>
                              </div>
                            }


                          </div>
                        </div>



                        <div className="card mb-3">
                          <div className="card-body">
                            <div className="card-title"><h4> {t("companyRepresentative")} </h4>
                            </div>


                            <div className="ligne">
                              <span className="titleligne">{t("user.name")}:</span>
                              <span className="descriptionligne">{userDetail.civilite ? t("user.civilities." + userDetail.civilite) : ""} {userDetail.prenom} {userDetail.nom}</span>
                            </div>


                            <div className="ligne">
                              <span className="titleligne">{t("profileentreprise11.1")} </span>
                              <span className="descriptionligne">{userDetail.email}</span>
                            </div>


                            <div className="ligne">
                              <span className="titleligne">{t("user.function")} </span>
                              <span className="descriptionligne">{t("user.functions." + userDetail.fonction)}</span>
                            </div>
                            <div className="ligne">
                              <span className="titleligne">{t("user.service")} </span>
                              <span className="descriptionligne">{t("user.services." + userDetail.service)}</span>
                            </div>




                            <div className="ligne">
                              <span className="titleligne">{t("user.phone")} </span>
                              <span className="descriptionligne">{userDetail.telephone}</span>
                            </div>

                            <div className="ligne">
                              <span className="titleligne">{t("user.mobile")}</span>
                              <span className="descriptionligne">{userDetail.mobile}</span>
                            </div>


                            {userDetail.facebook.includes("http") &&
                              <div className="ligne">
                                <span className="titleligne">{t("user.facebook")}</span>
                                <a href={userDetail.facebook} target="_blank" className="descriptionligne">{userDetail.facebook}</a>
                              </div>
                            }

                            {userDetail.tweeter.includes("http") &&
                              <div className="ligne">
                                <span className="titleligne">{t("user.twitter")}</span>
                                <a href={userDetail.tweeter} target="_blank" className="descriptionligne">{userDetail.tweeter}</a>
                              </div>
                            }
                          </div>
                        </div>





                        <div className="card mb-3">
                          <div className="card-body">
                            <div className="card-title"><h4>{t("user.openingHours")}</h4></div>
                            <OpeningHours hours={userDetail.entreprise.heures_ouverture} viewOnly={true} />
                          </div>
                        </div>


                        <div className="card mb-3">
                          <div className="card-body">
                            <div className="card-title"><h4>{t("profileentreprise14.1")}</h4></div>

                            <Mapss lat={userDetail.entreprise.lat || 0} lon={userDetail.entreprise.lng || 0} />
                          </div>
                        </div>








                        {(userDetail.entreprise.facebook?.includes("http") || userDetail.entreprise.linkedin?.includes("http") || userDetail.entreprise.tweeter?.includes("http") || userDetail.entreprise.instagramme?.includes("http")) &&
                          <div className="card" >
                            <div className="card-body">
                              <div className="card-title"><h4>{t("profileentreprise1.1")}</h4></div>
                              <div className="reseau">
                                {userDetail.entreprise.facebook?.includes("http") &&
                                  <h6 style={{
                                    textWrap: "nowrap",
                                    textOverflow: "ellipsis",
                                    overflow: "hidden"
                                  }}>
                                    <i className="fab fa-facebook-square mr-2"></i>
                                    <a href={userDetail.entreprise.facebook} target="_blank">{userDetail.entreprise.facebook}</a>
                                  </h6>
                                }


                                <br />

                                {userDetail.entreprise.linkedin?.includes("http") &&
                                  <h6 style={{
                                    textWrap: "nowrap",
                                    textOverflow: "ellipsis",
                                    overflow: "hidden"
                                  }}>
                                    <i className="fab fa-linkedin mr-2"></i>
                                    <a href={userDetail.entreprise.linkedin} target="_blank">{userDetail.entreprise.linkedin}</a>
                                  </h6>
                                }

                                <br />




                                {userDetail.entreprise.tweeter?.includes("http") &&
                                  <h6 style={{
                                    textWrap: "nowrap",
                                    textOverflow: "ellipsis",
                                    overflow: "hidden"
                                  }}>
                                    <i className="fab fa-twitter mr-2"></i>
                                    <a href={userDetail.entreprise.tweeter} target="_blank">{userDetail.entreprise.tweeter}</a>
                                  </h6>
                                }


                                <br />

                                {userDetail.entreprise.instagramme?.includes("http") &&
                                  <h6 style={{
                                    textWrap: "nowrap",
                                    textOverflow: "ellipsis",
                                    overflow: "hidden"
                                  }}>
                                    <i className="fab fa-instagram mr-2"></i>
                                    <a href={userDetail.entreprise.instagramme} target="_blank">{userDetail.entreprise.instagramme}</a>
                                  </h6>
                                }



                              </div>

                            </div>
                          </div>
                        }
                      </div>






                      <div className="col-md-8">
                        {userDetail.entreprise.about &&
                          <div className="card mb-3" >
                            <div className="card-body">
                              <div className="card-title"><h4>{t("presentation")}</h4></div>

                              <div className="description"><p>{userDetail.description}</p></div>

                              <div style={{ color: "#000", fontSize: 14 }}>
                                {userDetail.entreprise.about}
                              </div>
                            </div>
                          </div>
                        }


                        <div className="card">
                          <div className="card-body">
                            <Tabs style={{ width: "100%" }}>
                              <TabList>
                                <Tab>{t("profileentreprise17.1")}</Tab>
                                <Tab>{t("profileentreprise18.1")}</Tab>
                              </TabList>






                              <TabPanel>
                                <LoaderComponent isLoading={isAdsProductsLoading}>
                                  <ProductsComponent itemsPerPage={5} items={productList} />
                                </LoaderComponent>
                              </TabPanel>





                              <TabPanel>
                                <LoaderComponent isLoading={isAdsProductsLoading}>
                                  <AdsComponent itemsPerPage={5} items={adsList} />
                                </LoaderComponent>
                              </TabPanel>

                            </Tabs>
                          </div>
                        </div>
                      </div>
                    </div>






                  </div>
                </div>
              </div>

            </>
        )}
      </LoaderComponent>
      <Footer />
    </>

  );
};

export default ProfileEntreprise;